import { render, staticRenderFns } from "./StandaloneWizard.vue?vue&type=template&id=776fcd4a&scoped=true&"
import script from "./StandaloneWizard.vue?vue&type=script&lang=js&"
export * from "./StandaloneWizard.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneWizard.vue?vue&type=style&index=0&id=776fcd4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776fcd4a",
  null
  
)

export default component.exports